import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-arrays-totals',
  slug: 'totals',
  title: 'Cart totals that add up',
  type: 'code',
  estSeconds: 420,
  contentVersion: 1,
});
